'use client'
import React from 'react'

import LocationIntro from '../../sections/locationIntro'
import RichTextSection from '../../sections/richtext'
import UpcomingEvents from '../../sections/upcomingEvents'

import BreadCrumbs from '../../sections/breadcrumbs'
import SkewedCta from '../../sections/skewedCta'
import { buildLocalHost } from '@/core/utils/buildHost'

const EventIndexPage = ({
  intro_text,
  intro_cta,
  body,
  breadcrumbs,
  get_filters,
  cta,
  event_categories,
  host,
}) => {
  const ctaData = cta?.length > 0 && {
    title: cta[0].value?.link?.text,
    href: cta[0].value?.link?.href || cta[0].value?.link?.external_url,
    img: cta[0].value?.image,
    text: cta[0].value?.text,
  }

  const introCtaData =
    (intro_cta?.length && {
      text: intro_cta[0].value?.text,
      link: {
        href:
          intro_cta[0].value?.link?.href ||
          intro_cta[0].value?.link?.external_url,
        text: intro_cta[0].value?.link?.text,
      },
    }) ||
    {}

  const hostToUse = host ? host : buildLocalHost()

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={60} />
      <LocationIntro intro={intro_text} cta={introCtaData} />

      <UpcomingEvents
        eventCategories={event_categories}
        filters={get_filters?.filters}
        perPage={12}
        host={hostToUse}
      />

      {ctaData && (
        <SkewedCta
          title={ctaData.title}
          text={ctaData.text}
          href={ctaData.href}
          image={ctaData.img}
          padding={136}
        />
      )}

      {body?.map((item, ind) => {
        return <RichTextSection key={`eventindex-${ind}`} {...item.value} />
      })}
    </>
  )
}

export default EventIndexPage
